import React from 'react';
import TeamCard from './TeamCard';
import './TeamCard.css';
import './Teams.css';
import { Helmet } from 'react-helmet'; // Import Helmet

const teamsData = [
    {
        id: 1,
        name: "Team Alpha",
        coach: "John Doe",
        players: ["Player A", "Player B", "Player C"],
        logo: "output-onlinepngtools.png"
    },
    {
        id: 2,
        name: "Team Beta",
        coach: "Jane Smith",
        players: ["Player D", "Player E", "Player F"],
        logo: "output-onlinepngtools.png"
    },
    {
        id: 3,
        name: "Team Charlie",
        coach: "Alice Johnson",
        players: ["Player G", "Player H", "Player I"],
        logo: "output-onlinepngtools.png"
    },
    {
        id: 4,
        name: "Team Delta",
        coach: "Bob Brown",
        players: ["Player J", "Player K", "Player L"],
        logo: "output-onlinepngtools.png"
    },
    {
        id: 5,
        name: "Team Echo",
        coach: "Carol White",
        players: ["Player M", "Player N", "Player O"],
        logo: "output-onlinepngtools.png"
    }
    // Add more team data as needed with unique ids
];

function Teams() {
    return (
        <div className="teams-grid">
                <Helmet>
                <title>Teams at RCScouting - Explore Rocket League Teams</title>
                <meta name="description" content="Discover and connect with top Rocket League teams on RCScouting. Explore teams, find potential matches, and join the community." />
            </Helmet>
            {teamsData.map(team => (
                <TeamCard key={team.id} team={team} />
            ))}
        </div>
    );
}

export default Teams;
